import React, { useContext } from "react";
import { Box, IconButton, Tooltip, Grid, Button } from "@mui/material";
import AddBoxOutlinedIcon from "@mui/icons-material/AddBoxOutlined";
import IndeterminateCheckBoxOutlinedIcon from "@mui/icons-material/IndeterminateCheckBoxOutlined";
import EventIcon from "@mui/icons-material/Event";
import AddIcon from "@mui/icons-material/Add";
import StyledBadge from "./styledBadge";
import AppDataContext from "../../common/appContext";
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
  badgePlusIcon: {
    color: "#fff",
    padding: "2px",
    fontSize: "1.2rem",
  },
  gridContainer: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  gridLeft: {
    display: "flex",
    justifyContent: "flex-start",
  },
  gridRight: {
    display: "flex",
    justifyContent: "flex-end",
  },
}));

const CalendarEventHeaderBar = ({
  setIsPanelOpen,
  handleExpand,
  expandedAccordions,
  filteredEvents,
}) => {
  const classes = useStyles();
  const { user } = useContext(AppDataContext);

  return (
    <Grid container className={classes.gridContainer} alignItems="center">
      <Grid item xs={12} className={classes.gridRight}>
        {user && user.isAdmin && (
          <Tooltip title="Add Event">
            <Button
              onClick={() => setIsPanelOpen(true)}
              size="small"
              startIcon={
                <>
                  <StyledBadge
                    badgeContent={<AddIcon className={classes.badgePlusIcon} />}
                  >
                    <EventIcon color="primary" />
                  </StyledBadge>
                </>
              }
            >
              Add Event
            </Button>
          </Tooltip>
        )}
        <Tooltip title={"Expand All"}>
          <span>
            <IconButton
              onClick={() => handleExpand(true)}
              disabled={
                expandedAccordions?.length > 0 &&
                filteredEvents?.length === expandedAccordions?.length
              }
            >
              <AddBoxOutlinedIcon
                color={
                  expandedAccordions?.length === 0 ||
                  filteredEvents?.length !== expandedAccordions?.length
                    ? "primary"
                    : "inherit"
                }
                fontSize="large"
              />
            </IconButton>
          </span>
        </Tooltip>
        <Tooltip title={"Collapse All"}>
          <span>
            <IconButton
              onClick={() => handleExpand(false)}
              disabled={expandedAccordions?.length === 0}
            >
              <IndeterminateCheckBoxOutlinedIcon
                color={expandedAccordions?.length > 0 ? "primary" : "inherit"}
                fontSize="large"
              />
            </IconButton>
          </span>
        </Tooltip>
      </Grid>
    </Grid>
  );
};

export default CalendarEventHeaderBar;
